import React from 'react';
import { DataGrid } from '../../layout';

const ORDER_SEARCH_KEYS = ['InternalOrdNo', 'ExternalOrdNo'];
const ORDER_INITIAL_SORT = { key: 'OrderDate', dir: 'desc' };

const getOrderStatus = (order) => {
    if (order.Cancelled === '1') return { label: 'Annullato', className: 'bg-red-100 text-red-700' };
    if (order.Delivered === '1' && order.Invoiced === '1') return { label: 'Completato', className: 'bg-green-100 text-green-700' };
    if (order.Delivered === '1') return { label: 'Consegnato', className: 'bg-yellow-100 text-yellow-700' };
    if (order.ConfirmedDeliveryDate) return { label: 'Confermato', className: 'bg-blue-100 text-blue-700' };
    return { label: 'In attesa', className: 'bg-gray-100 text-gray-600' };
};

const ClientOrdersList = ({
    clientOrders,
    loadingOrders,
    currentClient,
    handleEditOrder,
    formatDate,
    formatCurrency
}) => {
    const columns = [
        {
            key: 'InternalOrdNo',
            header: 'N. Ordine',
            sortValue: (o) => o.InternalOrdNo,
            render: (o) => (
                <>
                    {o.InternalOrdNo}
                    {o.ExternalOrdNo && (
                        <span className="ml-2 text-xs text-gray-400">(APP: {o.ExternalOrdNo})</span>
                    )}
                </>
            )
        },
        {
            key: 'OrderDate',
            header: 'Data',
            sortValue: (o) => (o.OrderDate ? new Date(o.OrderDate).getTime() : null),
            render: (o) => formatDate(o.OrderDate)
        },
        {
            key: 'PayableAmount',
            header: 'Importo',
            sortValue: (o) => parseFloat(o.PayableAmount) || 0,
            render: (o) => formatCurrency(o.PayableAmount)
        },
        {
            key: 'status',
            header: 'Stato',
            sortValue: (o) => getOrderStatus(o).label,
            render: (o) => {
                const status = getOrderStatus(o);
                return <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${status.className}`}>{status.label}</span>;
            }
        },
        {
            key: 'actions',
            header: 'Azioni',
            align: 'center',
            render: (o) => (
                <button
                    onClick={() => handleEditOrder(o)}
                    className="px-3 py-1.5 text-xs font-semibold border border-blue-500 text-blue-600 rounded-lg hover:bg-blue-50 transition-colors"
                >
                    Modifica
                </button>
            )
        }
    ];

    return (
        <div className="py-4">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Ordini del cliente {currentClient?.CompanyName}</h3>
            {loadingOrders ? (
                <div className="flex justify-center py-12">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-500"></div>
                </div>
            ) : clientOrders.length > 0 ? (
                <div className="bg-white shadow-md rounded-lg overflow-hidden">
                    <DataGrid
                        columns={columns}
                        rows={clientOrders}
                        rowKey="InternalOrdNo"
                        searchKeys={ORDER_SEARCH_KEYS}
                        searchPlaceholder="Cerca ordine..."
                        initialSort={ORDER_INITIAL_SORT}
                    />
                </div>
            ) : (
                <div className="text-center py-8 text-gray-500">
                    Nessun ordine trovato per questo cliente.
                </div>
            )}
        </div>
    );
};

export default ClientOrdersList;
